module.exports = __webpack_public_path__ + "static/media/before_omikuji.d7d88c3.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newyear/2024/before_omikuji.mp4
// module id = kT4X
// module chunks = 7